import {BrowserRouter , Routes, Route} from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import LoginPage from './Pages/login';
import ProtectedRoute from './Pages/common/ProtectedRoute';
import SideMenu from './Layouts/SideMenu';
import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import Clients from './Pages/Clients';
import TaxReturns from './Pages/TaxReturns';
import W2s from './Pages/W2s';
import Client1099Divs from './Pages/1099Divs';
import Client1099Ints from './Pages/1099Ints';
import Client1099Bs from './Pages/1099Bs';
import K1s from './Pages/K1s';
import Rentals from './Pages/Rentals';
import Tasks from './Pages/Tasks';
import TaskTaxTopics from './Pages/TaskTaxTopics';
import TaxDocuments from './Pages/TaxDocuments';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showSessionPopup, setShowSessionPopup] = useState(sessionStorage.getItem("taxSessionExpired") === "true");

  useEffect(()=> {
    const token = localStorage.getItem("taxToken");
    const expiryTime = localStorage.getItem("taxExpiryTime");
    if(!token || !expiryTime) {
      return;
    }
    const currentTime = new Date().getTime();
    const remainingTime = Number(expiryTime) - currentTime;
    if(remainingTime <= 0) {
      localStorage.clear();
      sessionStorage.setItem("taxSessionExpired", "true");
      setShowSessionPopup(true);
      return;
    }
    const timer = setTimeout(() => {
      localStorage.clear();
      sessionStorage.setItem("taxSessionExpired", "true");
      setShowSessionPopup(true);
    }, remainingTime);
    return () => clearTimeout(timer);
  }, [navigate]);

  const handleSessionExpired = () => {
    sessionStorage.setItem("taxSessionExpired", "false");
    setShowSessionPopup(false)
    navigate("/login")
  }
  return (
    <div>
        <>
        <div style={{display: "flex", height: "100vh", overflow: "hidden"}}>
        {location.pathname !=="/" && location.pathname !=="/login" && <SideMenu/>}
        <div style={{flex: 1, background: "#e0f0ff", minHeight: "100vh", overflow: "auto"}}>
         <Routes>
          <Route path="/login" element={<LoginPage />} />
           <Route path="/">
            <Route index element={<LoginPage/>} />
          </Route>
          <Route path="/Pages/Clients">
            <Route index element={<ProtectedRoute><Clients/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaxReturns">
            <Route index element={<ProtectedRoute><TaxReturns/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/W2s">
            <Route index element={<ProtectedRoute><W2s/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Divs">
            <Route index element={<ProtectedRoute><Client1099Divs/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Ints">
            <Route index element={<ProtectedRoute><Client1099Ints/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/1099Bs">
            <Route index element={<ProtectedRoute><Client1099Bs/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/K1s">
            <Route index element={<ProtectedRoute><K1s/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/Rentals">
            <Route index element={<ProtectedRoute><Rentals/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/Tasks">
            <Route index element={<ProtectedRoute><Tasks/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaskTaxTopics">
            <Route index element={<ProtectedRoute><TaskTaxTopics/></ProtectedRoute>} />
          </Route>
          <Route path="/Pages/TaxDocuments">
            <Route index element={<ProtectedRoute><TaxDocuments/></ProtectedRoute>} />
          </Route>
         </Routes>
         <Dialog header="Session Expired" visible={showSessionPopup} baseZIndex={99999} closable={false} modal style={{width: '25rem'}}>
          <p>Your session has expired. Please login again.</p>
          <div className='flex justify-content-end mt-4'>
            <Button label="OK" onClick={handleSessionExpired}/>
          </div>
         </Dialog>
         </div>
         </div>
       </>
      {/* <h1>Hello World !!!</h1> */}
    </div>
  );
}

function App() {
  return (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
  );
}

export default App;